import { render } from "./NotFound.vue?vue&type=template&id=3aa08f9a&scoped=true"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"

import "./NotFound.vue?vue&type=style&index=0&id=3aa08f9a&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1815703633/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3aa08f9a"]])

export default __exports__